module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "row org-tree"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('tree-view', {
    attrs: {
      "model": _vm.orgs,
      "func": "1,2,3,5"
    },
    on: {
      "add": _vm.add,
      "del": _vm.del,
      "update": _vm.update,
      "qrcode": _vm.qrcode
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-title bg-primary color-white"
  }, [_vm._v("\n              新增\\修改组织信息\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('form', {
    attrs: {
      "id": "orgazination-edit-form"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("组织名称")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.name),
      expression: "org.name"
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "text",
      "placeholder": "请输入组织名称",
      "required": ""
    },
    domProps: {
      "value": (_vm.org.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.org.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("排序")]), _vm._v(" "), _c('div', {
    staticClass: "m-t-xs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.org.sort),
      expression: "org.sort"
    }],
    staticClass: "input input-md",
    attrs: {
      "type": "number",
      "value": "0",
      "placeholder": "排序序号",
      "min": "0",
      "step": "1",
      "required": ""
    },
    domProps: {
      "value": (_vm.org.sort)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.org.sort = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("上级组织")]), _vm._v(" "), _vm._l((_vm.org.pids), function(parent, indexd) {
    return _c('div', {
      key: indexd,
      staticClass: "m-t-xs clearfix"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parent.selected),
        expression: "parent.selected"
      }],
      staticClass: "select input-md col-xs-12",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          parent.selected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
        }, function($event) {
          _vm.selectParent($event, indexd)
        }]
      }
    }, _vm._l((parent.options), function(p) {
      return _c('option', {
        key: p._id,
        domProps: {
          "value": p._id
        }
      }, [_vm._v(_vm._s(p.name))])
    }))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "actions text-center"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default m-r-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.is_processing === 1
    },
    on: {
      "click": _vm.upsert
    }
  }, [_vm._v("保存")])])])])])])])])]), _vm._v(" "), (_vm.modal.show) ? _c('div', [_c('div', {
    staticClass: "overlay"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n          " + _vm._s(_vm.modal.title) + "\n          "), _c('span', {
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "min-height": "300px",
      "width": "400px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('img', {
    attrs: {
      "src": _vm.modal.img,
      "alt": "",
      "width": "360",
      "height": "360"
    }
  })])])])])])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 table-filter"
  }, [_c('div', {
    staticClass: "row p-b-sm"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "table-name"
  }, [_vm._v("组织结构")]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92b811b2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/organization.vue
// module id = 498
// module chunks = 1